import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface DummySimulation {
  id: string;
  monthlyPayment: number;
  product: string;
  rate: number;
}

@Injectable({
  providedIn: 'root',
})
export class SimulationService {
  private readonly http = inject(HttpClient);

  async simulateDummy(): Promise<DummySimulation> {
    const { data } = await firstValueFrom(this.http.post<{ data: DummySimulation; }>('/api/mortgage-seller/simulate-dummy', null));
    return data;
  }
}
